<div class="modal-backdrop" [@modalFadeIn]>
  <div class="modal-container">
    <div class="modal confirm-payment-modal">

      <!-- Header -->
      <div class="modal-header">
        <div class="modal-header-content">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 256 256" fill="currentColor" class="modal-header-icon">
            <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM32,96H224v24H32Z" opacity="0.3"/>
            <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,144H32V64H224ZM32,96H224v24H32Z"/>
            <rect x="48" y="144" width="40" height="16" rx="8"/>
          </svg>
          <div>
            <h3 class="modal-title">Confirmar Pagamento</h3>
            <p class="modal-subtitle">{{ data.plan.name }}</p>
          </div>
        </div>
        <button mat-icon-button (click)="close()" aria-label="Fechar">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="modal-body">

        <!-- STEP 1: Configurar pagamento -->
        <ng-container *ngIf="!createdPayment()">

          <!-- Resumo do plano -->
          <div class="plan-summary-box alert alert-info">
            <mat-icon>info_outline</mat-icon>
            <div class="plan-summary-text">
              <span>Valor total do plano:</span>
              <strong class="plan-total-value">{{ formatCurrency(data.plan.finalTotal) }}</strong>
            </div>
          </div>

          <!-- Método de pagamento -->
          <div class="form-section">
            <label class="field-label">Método de Pagamento</label>
            <div class="method-options">
              <button
                *ngFor="let m of paymentMethods"
                class="method-option"
                [class.selected]="selectedMethod() === m.value"
                (click)="selectedMethod.set(m.value)"
                type="button">
                <mat-icon>{{ m.icon }}</mat-icon>
                <span>{{ m.label }}</span>
              </button>
            </div>
          </div>

          <!-- Número de parcelas -->
          <div class="form-section">
            <label class="field-label">Número de Parcelas</label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Selecione as parcelas</mat-label>
              <mat-select
                [ngModel]="selectedInstallments()"
                (ngModelChange)="selectedInstallments.set($event)">
                <mat-option *ngFor="let n of installmentOptions" [value]="n">
                  {{ n }}x de {{ formatCurrency(data.plan.finalTotal! / n) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Preview do valor por parcela -->
          <div class="installment-preview">
            <div class="preview-row">
              <span class="preview-label">Valor por parcela:</span>
              <span class="preview-value">{{ formatCurrency(installmentValue()) }}</span>
            </div>
            <div class="preview-row">
              <span class="preview-label">Total:</span>
              <span class="preview-value total">{{ formatCurrency(data.plan.finalTotal) }}</span>
            </div>
          </div>

        </ng-container>

        <!-- STEP 2: Parcelas criadas com sucesso -->
        <ng-container *ngIf="createdPayment()">
          <div class="alert alert-success">
            <mat-icon>check_circle</mat-icon>
            <span>Pagamento criado com sucesso! Abaixo estão suas parcelas.</span>
          </div>

          <div class="installments-list">
            <div
              *ngFor="let inst of createdPayment()!.installments"
              class="installment-item">
              <div class="inst-number">#{{ inst.installmentNumber }}</div>
              <div class="inst-info">
                <span class="inst-amount">{{ formatCurrency(inst.amount) }}</span>
                <span class="inst-date">Vence em {{ formatDate(inst.dueDate) }}</span>
              </div>
              <span class="badge" [class]="getInstallmentStatusClass(inst.status)">
                {{ getInstallmentStatusLabel(inst.status) }}
              </span>
            </div>
          </div>
        </ng-container>

      </mat-dialog-content>

      <!-- Footer -->
      <mat-dialog-actions class="modal-footer">
        <button mat-button (click)="close()">
          {{ createdPayment() ? 'Fechar' : 'Cancelar' }}
        </button>
        <button
          *ngIf="!createdPayment()"
          mat-flat-button
          color="primary"
          (click)="onConfirm()"
          [disabled]="isLoading()">
          <mat-spinner *ngIf="isLoading()" diameter="18" class="btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!isLoading()">send</mat-icon>
          {{ isLoading() ? 'Processando...' : 'Confirmar Pagamento' }}
        </button>
      </mat-dialog-actions>

    </div>
  </div>
</div>
